import { redirect } from '@tanstack/react-router'
import { resolveLegacyRedirect } from './public-routes'

export function throwLegacyRedirect(pathname: string, search?: string) {
  const target = resolveLegacyRedirect(pathname, search)
  if (!target) return

  throw redirect({
    href: target,
    replace: true,
    statusCode: 301,
  })
}
